import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import { useForm, Controller } from 'react-hook-form';
import SearchIcon from '@material-ui/icons/Search';
import ReplayIcon from '@material-ui/icons/Replay';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import ClearIconML from '@/components/ClearIconML/index';
import { CAMPAIGNTYPE, OPERATESTATUS } from '@/constants';
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
} from '@material-ui/core';
import { useIntl } from 'umi';
// import { sexMapList, channelMapList } from '@/constants.js';
import Button from '@material-ui/core/Button';
import SearchGroupStyled from './SearchGroupStyled';
// import webStorage from '@/utils/storageManager';

const SearchGroup = (props) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const { query, searchRef } = props;
  const { handleSearch, restClick } = props;
  const { title, type, status } = query;
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    watch,
    // register,
  } = useForm({
    defaultValues: {
      title,
      type,
      status,
    },
  });
  //置空输入框
  const handleClearType = () => {
    setValue('type', '');
    // reset('type', '');
  };
  const handleClearStatus = () => {
    setValue('status', '');
    // reset('status', '');
  };

  const watchType = watch('type');
  const watchStatus = watch('status');
  const [titleValue, setTitleValue] = useState();
  useEffect(() => {
    if (title) {
      setTitleValue(title);
    }
  }, [title]);
  //查询
  const handleClickSearch = (values) => {
    handleSearch(values);
  };
  //重置
  const handleClickReset = () => {
    setTitleValue('');
    const resetSearch = {
      title: '',
      type: '',
      status: '',
    };
    reset(resetSearch);
    restClick && restClick(resetSearch);
  };
  return (
    <SearchGroupStyled>
      <form onSubmit={handleSubmit(handleClickSearch)}>
        <Box className="search-wrapper">
          <Box className="left">
            <Box className="first-line">
              <Controller
                render={(rp) => (
                  <TextField
                    variant="standard"
                    name="title"
                    control={control}
                    onChange={(e) => {
                      setValue('title', e.target.value);
                      setTitleValue(e.target.value);
                      return rp.value;
                    }}
                    value={rp.value ?? titleValue}
                    id="basic"
                    className="input"
                    label={formatMessage({ id: 'marketing.people.n05.lbl01' })}
                    defaultValue={''}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setTitleValue('');
                              setValue('title', '');
                            }}
                            edge="end"
                          >
                            {titleValue ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="title"
                control={control}
                // placeholder="请输入优惠券名称"
                id="basic"
                className="input"
                label={formatMessage({ id: 'marketing.people.n05.lbl01' })}
                defaultValue={''}
              />
              <FormControl variant="standard" className="channel single-select">
                <InputLabel>
                  {' '}
                  {formatMessage({ id: 'marketing.people.n05.rdo02' })}
                </InputLabel>
                <Controller
                  as={
                    <Select className="select">
                      {CAMPAIGNTYPE.map((item) => (
                        <MenuItem
                          key={item.value}
                          value={item.value}
                          name={item.value}
                        >
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  }
                  label={formatMessage({ id: 'marketing.people.n05.rdo02' })}
                  name="type"
                  placeholder="全部类型"
                  variant="standard"
                  defaultValue=""
                  control={control}
                />
                <ClearIconML
                  handleClick={handleClearType}
                  clearValue={watchType}
                ></ClearIconML>
              </FormControl>
              <FormControl variant="standard" className="gender single-select">
                <InputLabel>
                  {formatMessage({ id: 'marketing.people.n05.rdo03' })}
                </InputLabel>
                <Controller
                  as={
                    <Select className="select">
                      {OPERATESTATUS.map((item) => (
                        <MenuItem
                          key={item.value}
                          value={item.value}
                          name={item.value}
                        >
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  }
                  label={formatMessage({ id: 'marketing.people.n05.rdo03' })}
                  placeholder="全部状态"
                  name="status"
                  variant="standard"
                  control={control}
                  defaultValue=""
                />
                <ClearIconML
                  handleClick={handleClearStatus}
                  clearValue={watchStatus}
                ></ClearIconML>
              </FormControl>
            </Box>
          </Box>
          <Box className="button-group">
            <Button
              variant="contained"
              color="secondary"
              className="reset"
              onClick={handleClickReset}
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'comm.action.btn.06' })}
            </Button>

            <Button
              data-log={JSON.stringify({
                oid: 'btn_marketing_activity_user_operation_list_search',
                events: ['_ev'],
                params: {
                  initUrl: window.location.origin + window.location.pathname,
                },
              })}
              ref={searchRef}
              variant="contained"
              type="submit"
              className="search"
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            >
              {formatMessage({ id: 'comm.action.btn.01' })}
            </Button>
          </Box>
        </Box>
      </form>
    </SearchGroupStyled>
  );
};
export default SearchGroup;
